let blogInputs = $('.blog-search, .blog-search-mobile'),
    blogKeywords = $('.blog-nav-keywords-item'),
    articles = $('.blog-articles'),
    goBack = $($('.blog .title, .blog-search-back:not(.top)')[0]),
    currentHref= window.location.href,
    showMore = $(".blog-more"),
    shortSearch = false;    

if (blogInputs.length !== 0 && shortSearch) {

    if (window.innerWidth < 992 ) {
        blogInputs.find('input').addClass('hidden');
    }

    blogInputs.find('input').focus(function () {
        
        if (window.innerWidth < 992 ) {
            if (goBack.length !== 0 && window.innerWidth < 768) {
                goBack.addClass('hidden');
            }

            blogInputs.find('img').addClass('left')
            
            $(this).removeClass('hidden');
            // blogInputs.addClass('active');
        }
    });
    
    blogInputs.find('input').focusout(function () {
        
        
        if (window.innerWidth < 992) {
            blogInputs.find('img').removeClass("left");
            
            if (goBack.length !== 0) {
                goBack.removeClass('hidden');
            }

            if ($(this).val()) {
                $(this).addClass('hidden')
            } 
            // blogInputs.removeClass('active');
        }
        
    });
}

if (blogKeywords.length !== 0) {
    blogKeywords.each((_,item) => {
        
        $(item).on('click', function(e) {
            if (!$(item).attr('disabled')) {
                blogKeywords.attr("disabled", "true");
                // $(this).toggleClass('active');                    
                
                if ($(this).attr('data-slug') == '*') {
                    // blogKeywords.removeClass("active");
                    window.location.href = window.location.origin + window.location.pathname;
                }
                else {
                    if (!tags.length) {
                        window.location.href = window.location.origin + '/blog' + `/?tags=${$(this).attr('data-slug')}`;
                    }    
                    else {
                        if (tags.includes($(this).attr('data-slug'))) {
                            if (tags.length == 1) {
                                window.location.href = window.location.origin + '/blog';
                            }
                            else {
                                window.location.href = window.location.origin + '/blog' + `/?tags=${tags.filter(el => el !== $(this).attr('data-slug')).join(',')}`
                            }                    
                        }
                        else {
                            window.location.href = window.location.origin + '/blog' + `/?tags=${tags.join(',')},${$(this).attr('data-slug')}`;
                        }
                    }
                }
                
            }
        });
        
        // $(item).find('.close').on('click', function(e) {});
        // window.location.href = currentHref;
    })
}

if (showMore.length !== 0) {
    var ppp = showMore.attr('data-page-max'); // Post per page
    var pageNumber = 1;
    
    showMore.on('click', function(e) {            
        pageNumber++;
        var str = '&page=' + pageNumber + '&action=blog_get_more';
        
        // if (pageNumber <= ppp) {
            showMore.addClass("disabled");

            $.ajax({
                type: "POST",
                dataType: "html",
                url: myajax.url,
                data: str,
                success: function(data){
                    showMore.removeClass("disabled");
                    
                    var $data = $($.parseHTML(JSON.parse(data).html));
                    if($data.length){
                        articles.append($data);
                    }

                    if (pageNumber == ppp) {
                        showMore.addClass('hidden')
                    }
                },
                error : function(jqXHR, textStatus, errorThrown) {
                    $(this).removeClass("disabled");
                    // $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
    
            });            
        // }
        return false;
    })
}